import axios from "axios";
import Format from "string-format";
import { analyticsTrackEvent } from "../_utils/common";
import {
  CREATE_BRANDKIT,
  CREATE_BRANDKIT_COLOR_PALLETE,
  DELETE_BRANDKIT,
  GET_BRANDKIT_BY_ID,
  LIST_BRANDKITS,
  UPDATE_BRANDKIT,
  UPDATE_BRANDKIT_COLOR_PALETTE,
} from "./endpoints";
import * as errorHandlerActions from "./errorHandlerActions";
import {
  ADD_BRANDKIT,
  DELETED_BRANDKIT,
  GET_BRANDKITS,
  SWITCH_BRANDKIT,
  UPDATED_BRANDKIT,
} from "./types";

export const switchBrandkit = (brandkit) => (dispatch) => {
  dispatch({
    type: SWITCH_BRANDKIT,
    payload: brandkit,
  });
};

export const fetchBrandkitById = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(Format(GET_BRANDKIT_BY_ID, id))
      .then((res) => {
        resolve(res.data);
      })
  })
};

export const fetchBrandKits = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(LIST_BRANDKITS)
      .then((res) => {
        dispatch({
          type: GET_BRANDKITS,
          payload: res.data,
        });

        // Return brandkits
        resolve(res.data.results);
      })
      .catch((error) => dispatch(errorHandlerActions.handleHTTPError(error)));
  });
};

export const addBrandKit = (count, props, signalToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        CREATE_BRANDKIT,
        { title: `Brandkit ${count + 1}` },
        { cancelToken: signalToken.token }
      )
      .then((res) => {
        analyticsTrackEvent("createBrandKit");
        dispatch({
          type: ADD_BRANDKIT,
          payload: res.data,
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
        reject(error);
      });
  });
};

export const updateBrandKit = (id, newValue, signalToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        Format(UPDATE_BRANDKIT, id),
        { title: newValue },
        { cancelToken: signalToken.token }
      )
      .then((res) => {
        analyticsTrackEvent("updateBrandKit");
        if (res.status === 200) {
          dispatch({
            type: UPDATED_BRANDKIT,
            payload: res.data,
          });
          resolve(res.data);
        }
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error));
        reject(error.repsonse);
      });
  })
};

export const deleteBrandKit = (id, signalToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(Format(DELETE_BRANDKIT, id), { cancelToken: signalToken.token })
      .then((res) => {
        analyticsTrackEvent("deletedBrandKit");
        if (res.status === 204) {
          dispatch({
            type: DELETED_BRANDKIT,
            payload: id,
          });
          resolve(res);
        }
      })
      .catch((error) => {
        reject(error);
        dispatch(errorHandlerActions.handleHTTPError(error));
      });
  });
};

export const addColorPalette = (id, signalToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        Format(CREATE_BRANDKIT_COLOR_PALLETE, id),
        {
          colors: [
            { rgb: "rgb(255, 255, 255)" },
          ],
        },
        { cancelToken: signalToken.token }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error));
        reject(error.response);
      });
  });
};

export const updateColorPalette =
  (brandId, paletteId, body, signalToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put(Format(UPDATE_BRANDKIT_COLOR_PALETTE, brandId, paletteId), body, {
          cancelToken: signalToken.token,
        })
        .then((res) => {
          dispatch(fetchBrandKits());
          resolve(res.data);
        })
        .catch((error) => {
          dispatch(errorHandlerActions.handleHTTPError(error));
          reject(error.response);
        });
    });
  };
